import React from "react";
import Layout from "../../components/layout/Layout";
import CastingCallCreate from "../../components/castingCalls/CastingCallCreate";

const CastingCallCreatePage = () => {
  return (
    <Layout>
      <div>
        <CastingCallCreate />
      </div>
    </Layout>
  );
};

export default CastingCallCreatePage;
